let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("atlDR")).then(() => parcelRequire('5lnHT'));